/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@jira/servicedesk__customer-service-form-edit/src/__generated__/FormEditQuery$parameters.ts';
import type { FormEditQuery } from '@jira/servicedesk__customer-service-form-edit/src/__generated__/FormEditQuery.graphql.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingFormEditAppEntryPointComponent = EntryPointComponent<
	{
		FormEditQuery: FormEditQuery;
	},
	{},
	{},
	{} | null
>;

export const helpCenterSettingFormEditAppEntryPoint: EntryPoint<
	HelpCenterSettingFormEditAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingFormEditAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-setting-form-edit-app" */ './HelpCenterSettingFormEditApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId, formId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			FormEditQuery: {
				parameters,
				variables: {
					cloudId,
					helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					templateFormAri: `ari:cloud:jira-customer-service::template-form/activation/${activationId}/${formId}`,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
